
import { CSSProperties, defineComponent, onMounted, PropType, reactive, ref } from 'vue'
import MessageBlock from '@/components/MessageBlock.vue'
import DButton from '@/components/base/DButton.vue'

import StatusIndicator, { StatusType } from '@/components/StatusIndicator.vue'

export type TimelineItemStyle = 'success' | 'error' | 'warning' | 'pending'
export type TimelineNodeData = {
  heading?: string;
  subHeading?: string;
  message?: string;
  description?: string;
  metaData?: Record<string, string | string[]>,
  type?: TimelineItemStyle,
  loading?: boolean,
  skeleton?: boolean;
  orbStyle?: CSSProperties;
}

interface DocumentViewerState {
  currentDialog: string,
  fulfillment: any,
  document: {
    labels: Array<any> | null,
    slip: Array<any> | null
  },
  dialog: {
    labels: boolean,
    slip: boolean
  }
}

export default defineComponent({
  name: 'TimelineNode',
  components: { MessageBlock, DButton, StatusIndicator },
  props: {
    heading: String,
    subHeading: String,
    updatedBy: String,
    metaData: {
      type: Object as PropType<Record<string, string | string[]>>,
    },
    description: String,
    message: String,
    type: {
      type: String as PropType<TimelineItemStyle>,
    },
    loading: {
      type: Boolean,
      default: false
    },
    skeleton: {
      type: Boolean,
      default: false
    },
    orbStyle: {
      type: Object as PropType<CSSProperties>,
      default: () => ({})
    }
  },
  setup (props) {
    const state = reactive<DocumentViewerState>({
      currentDialog: '',
      fulfillment: null,
      document: {
        labels: null,
        slip: null
      },
      dialog: {
        labels: false,
        slip: false
      }
    })
    const showDetails = ref(false)
    return {
      showDetails
    }
  }
})
